<template>
  <div>
    <div class="d-flex">
      <div>
        <v-chip
          color="red"
          text-color="white"
          label
          class="ma-0 px-2"
          small
        >
          LIVE
        </v-chip>
      </div>
      <div>
        <v-chip
          color="#999"
          dark
          class="ml-1 px-2"
          small
        >
          <Icon
            style="margin-top: -1px"
            :width="15"
            :height="15"
            :color="'white'"
            :icon="'eye-outline'"
            class="mr-1"
          />
          {{ views }}
        </v-chip>
      </div>
      <div class="aspect-ratio">
        <v-btn
          class="header-btn"
          fab
          small
          bottom
          left
          elevation="0"
          color="transparent"
          @click="cellphoneMode"
        >
          <Icon
            :width="24"
            :color="'#fff'"
            icon='aspect-ratio'
          />
          <span class="aspect-ratio-tip">Modo de visualización</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    room: {
      type: Object,
      default: null
    },
    video: {
      type: Object,
      default: null
    },
  },
  computed: {
    views () {
      return this.$store.state.rooms.item.views
    } 
  }
})
export default class Summary extends Vue {
  cellphoneMode () {
    this.$emit('cellphoneMode')
  }
}
</script>
<style>
  .header-btn{
    height: 24px !important;
  }

.aspect-ratio .aspect-ratio-tip {
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 8px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: -150%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 10px;
  right: 10px;
}

.aspect-ratio .aspect-ratio-tip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 90%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #555 transparent;
}

.aspect-ratio:hover .aspect-ratio-tip {
  visibility: visible;
  opacity: 1;
}
</style>
